import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PI } from '../../constants-types';
import {
    DemoAccountInfo,
    CreateCompanyCto,
    CreateCompanyResponse,
    UpdateDemoAccountResponse,
    DemoAccountUpdatePayload
} from '../../core-data-model';
import {
    InitDataService,
    UserProfileSettingsService
} from '../../system-services';

@Injectable({
    providedIn: 'root'
})
export class DemoAccountsRepositoryService {
    private http = inject(HttpClient);
    private userProfile = inject(UserProfileSettingsService);
    private initData = inject(InitDataService);

    createCompany(
        createCompanyCtos: CreateCompanyCto
    ): Observable<CreateCompanyResponse> {
        return this.http.post<CreateCompanyResponse>(
            this.demoAccountsApiEndpoint('demoaccount'),
            createCompanyCtos
        );
    }

    getDemoAccounts(): Observable<DemoAccountInfo[]> {
        return this.http.get<DemoAccountInfo[]>(
            this.demoAccountsApiEndpoint(`demoaccountinfo`)
        );
    }

    getDemoAccount(demoCompanyId: string): Observable<DemoAccountInfo> {
        let baseApi = PI?.appSettings?.demoAccountsApiUrl ?? '';
        baseApi = baseApi.replace(/\/$/, '').concat('/');
        const url = baseApi.concat(
            `api/v5/companies/${this.initData.user.companyId}/demoaccountinfo/${demoCompanyId}`
        );
        return this.http.get<DemoAccountInfo>(url);
    }

    public updateDemoAccount(
        payload: DemoAccountUpdatePayload
    ): Observable<UpdateDemoAccountResponse> {
        return this.http.patch<UpdateDemoAccountResponse>(
            this.demoAccountsApiEndpoint('demoaccount'),
            payload
        );
    }

    updateDemoAccountLastAccessed(
        companyGuid: string
    ): Observable<DemoAccountInfo> {
        let baseApi = PI?.appSettings?.demoAccountsApiUrl ?? '';
        baseApi = baseApi.replace(/\/$/, '').concat('/');
        const url = baseApi.concat(
            `api/v5/companies/${this.initData.user.companyId}/demoaccountinfo/lastAccessed`
        );
        return this.http.patch<DemoAccountInfo>(url, {
            companyGuid: companyGuid
        });
    }

    deleteDemoAccount(companyGuid: string): Observable<void> {
        return this.http.delete<void>(
            this.demoAccountsApiEndpoint(`demoaccount/${companyGuid}`)
        );
    }

    private demoAccountsApiEndpoint(
        endpoint: string,
        withCompanyId = true
    ): string {
        let baseApi = PI?.appSettings?.demoAccountsApiUrl ?? '';
        baseApi = baseApi.replace(/\/$/, '').concat('/');
        endpoint = endpoint.replace(/(^\/{0,2})|(\/{0,2}$)/g, '');

        return withCompanyId
            ? baseApi.concat(
                  `api/v5/companies/${this.userProfile.currentCompany}/${endpoint}`
              )
            : baseApi.concat(endpoint);
    }
}
